import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';
import ProgressBar from './ProgressBar';

export default styled(ProgressBar)`
  max-width: ${gridSizes('L')};
  width: 100%;
  margin: 0 ${gridSizes('M')} 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .prev-step {
    height: ${gridSizes('M')};
    width: 2px;
    background-color: var(--grey-mouse);
    border-bottom: solid 3px #fff;
    ${media.lessThan('small')`
      height: 19px;
    `}
  }

  .current-step {
    box-sizing: content-box;
    height: ${gridSizes('L')};
    width: ${gridSizes('L')};
    background-color: var(--grey-mouse);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    .state {
      box-sizing: content-box;
      height: ${gridSizes('M')};
      width: ${gridSizes('M')};
      background-color: var(--grey-mouse);
      border-radius: 50%;
      border: 2px solid var(--white);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .next-step {
    flex-grow: 1;
    width: 2px;
    background-color: var(--grey-mouse);
    border-top: solid 3px #fff;
  }

  &.in-standstill {
    .current-step {
      background-color: var(--accent500);
    }

    .state {
      background-color: var(--accent500);
    }
  }
  &.done {
    .prev-step {
      background-color: var(--greenKiwi);
    }
    .current-step {
      background-color: var(--greenKiwi);
    }
    .state {
      background-color: var(--greenKiwi);
    }
  }
  &.to-next {
    .prev-step {
      background-color: var(--greenKiwi);
    }
    .current-step {
      background-color: var(--greenKiwi);
    }
    .state {
      background-color: var(--greenKiwi);
    }
    .next-step {
      background-color: var(--greenKiwi);
    }
  }
  &.in-progress {
    .prev-step {
      background-color: var(--greenKiwi);
    }
    .current-step {
      background-color: var(--greenKiwi);
    }
  }
`;
